// SPA entry (§3 deviation, §18). Mounts the data-router. Auth gating (§18) is
// enforced in route loaders (see router.tsx) plus server-side on the worker.
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router.js";
import { ThemeProvider } from "./lib/theme.js";
import "./styles.css";

// Mock mode (?preview=1 / ?mock=1): serve mock API data so the real screens —
// incl. the pack station — run fully offline (design review + pack demo). The
// mock backend is a code-split chunk loaded ONLY when the flag is set, so it
// adds nothing to the default bundle. Available in any build (explicit opt-in).
function mockFlagSet(): boolean {
  try {
    const q = new URLSearchParams(window.location.search);
    if (q.get("preview") === "1" || q.get("mock") === "1") return true;
    if (q.get("preview") === "0" || q.get("mock") === "0") return false;
    return localStorage.getItem("cairn.preview") === "1";
  } catch {
    return false;
  }
}
if (mockFlagSet()) {
  const { mockEnabled, installMockFetch } = await import("./preview/mockApi.js");
  if (mockEnabled()) installMockFetch();
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("missing #root element");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>,
);
